import { BaseService } from './base-service';
import {
	GetActionPlansCountByReportRequestDTO,
	GetActionPlansCountByReportResponseDTO,
	GetActionPlansCountByReportsRequestDTO,
	GetActionPlansCountByReportsResponseDTO,
	GetActionPlanByOriginRequestDTO,
	GetActionPlanByOriginResponseDTO
} from '@/core/dto/action-plan';

export class ActionPlansService extends BaseService<any> {
	private static instance: ActionPlansService;

	private constructor(public readonly basePath: string = '/action_plan') {
		super();
	}

	public static getInstance(): ActionPlansService {
		if (!ActionPlansService.instance) {
			ActionPlansService.instance = new ActionPlansService();
		}
		return ActionPlansService.instance;
	}

	public async findAllByReportWithCount(
		params: GetActionPlansCountByReportRequestDTO
	): Promise<GetActionPlansCountByReportResponseDTO> {
		const url = this.basePath + `/v2/report/count`;
		const { data } = await this.getInstance().get<GetActionPlansCountByReportResponseDTO>(url, { params });
		return data;
	}

	public async findAllReportsWitchActionPlansCount(
		params: GetActionPlansCountByReportsRequestDTO
	): Promise<GetActionPlansCountByReportsResponseDTO[]> {
		const url = this.basePath + `/v2/report/origin/count`;
		const { data } = await this.getInstance().get<GetActionPlansCountByReportsResponseDTO[]>(url, { params });
		return data;
	}

	async findAllByOrigin(params: GetActionPlanByOriginRequestDTO): Promise<GetActionPlanByOriginResponseDTO> {
		const url = this.basePath + '/v2/by-origin';
		const { data } = await this.getInstance().get<GetActionPlanByOriginResponseDTO>(url, { params });
		return data;
	}
}
